import type { CSSProperties, ReactNode } from "react";
import css from "./primitives.module.css";

type DisplayProps = {
  children: ReactNode;
  /** From §2.2's scale. Drives which outline weight §2.1 calls for. */
  size: number;
  lineHeight?: number;
  as?: "h1" | "h2" | "h3" | "p" | "span" | "div";
  style?: CSSProperties;
  className?: string;
};

/**
 * §2.1: "Display outline treatment (mandatory on every display string)."
 * White fill, hard dark outline in 8 directions, one offset --panel-2 shadow.
 * A display string without it is wrong, so this component exists to make the
 * plain version the awkward one to write.
 */
export function Display({
  children,
  size,
  lineHeight,
  as: Tag = "span",
  style,
  className,
}: DisplayProps) {
  // §2.1: 2px offsets up to 32px type, 3px at 40px+.
  const outline = size >= 40 ? css.outline3 : css.outline2;
  const classes = [css.display, outline, className ?? ""].filter(Boolean).join(" ");
  return (
    <Tag className={classes} style={{ fontSize: size, lineHeight, ...style }}>
      {children}
    </Tag>
  );
}
